import { useEffect, useState } from 'react';
import { useShipForm } from '../../../context/shipForms';
import { AddressDto } from '../../../types';
import {
  formatDateWithDashes,
  sortedRatesTableData,
} from '../../../utils/helper';
import SearchField from '../../global-components/searchField';
import { useSnackbar } from 'notistack';

interface Props {
  setShowModal: any;
  selectedRate: any;
  setSelectedRate: any;
  rates: any;
  isPriceHidden: boolean;
  selectedLegsInfo: any;
  setSelectedLegsInfo: any;
  orderLeg: any;
}

const sortIcon = (
  <svg
    width='7'
    height='12'
    viewBox='0 0 7 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.7882 0.644001C3.75609 0.59959 3.71312 0.563278 3.663 0.538192C3.61287 0.513107 3.5571 0.5 3.50047 0.5C3.44385 0.5 3.38808 0.513107 3.33795 0.538192C3.28783 0.563278 3.24486 0.59959 3.21275 0.644001L0.0625043 4.97704C0.0260401 5.02701 0.00465731 5.08555 0.000677617 5.14629C-0.00330207 5.20703 0.0102749 5.26764 0.0399327 5.32155C0.0695906 5.37545 0.114195 5.42059 0.1689 5.45205C0.223606 5.48351 0.286319 5.50009 0.350227 5.5L6.65072 5.5C6.71448 5.49975 6.77696 5.48295 6.83145 5.45142C6.88593 5.41988 6.93036 5.3748 6.95995 5.32101C6.98954 5.26723 7.00317 5.20679 6.99938 5.14618C6.99559 5.08557 6.97452 5.02709 6.93844 4.97704L3.7882 0.644001Z'
      fill='#808080'
    />
    <path
      d='M3.2118 11.356C3.24391 11.4004 3.28688 11.4367 3.337 11.4618C3.38713 11.4869 3.4429 11.5 3.49953 11.5C3.55615 11.5 3.61192 11.4869 3.66205 11.4618C3.71217 11.4367 3.75514 11.4004 3.78725 11.356L6.9375 7.02296C6.97396 6.97299 6.99534 6.91445 6.99932 6.85371C7.0033 6.79297 6.98972 6.73236 6.96007 6.67845C6.93041 6.62455 6.8858 6.57941 6.8311 6.54795C6.77639 6.51649 6.71368 6.4999 6.64977 6.5H0.349279C0.285519 6.50025 0.223037 6.51705 0.168553 6.54858C0.114069 6.58012 0.069643 6.6252 0.0400537 6.67899C0.0104645 6.73277 -0.00316886 6.79321 0.000619828 6.85382C0.00440851 6.91443 0.0254759 6.97291 0.0615563 7.02296L3.2118 11.356Z'
      fill='#808080'
    />
  </svg>
);

function PickupAndDeliveryModals({
  setShowModal,
  rates,
  selectedRate,
  setSelectedRate,
  isPriceHidden,
  selectedLegsInfo,
  setSelectedLegsInfo,
  orderLeg,
}: Props) {
  const { getDestinationFormData, getOriginFormData } = useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const isTransferRequired: boolean =
    selectedRate?.main?.transfer_rates &&
    selectedRate?.main?.transfer_rates.length > 0;
  const legA1Routing =
    selectedLegsInfo &&
    selectedLegsInfo
      .filter((item: any) => item.leg === 'A1')
      .map((item: any) => item.routing);
  const legA2Routing =
    selectedLegsInfo &&
    selectedLegsInfo
      .filter((item: any) => item.leg === 'A2')
      .map((item: any) => item.routing);
  const destinationFormContextData: AddressDto = getDestinationFormData();
  const originFormContextData: AddressDto = getOriginFormData();
  const [searchPickup, setSearchPickup] = useState('');
  const [searchTransfer, setSearchTransfer] = useState('');
  const [searchDelivery, setSearchDelivery] = useState('');
  const [section, setSection] = useState(
    isTransferRequired ? 'transfer' : 'pickup'
  );

  const [selectedPickup, setSelectedPickup] = useState<any>(
    selectedRate?.pickup
  );
  const [selectedDelivery, setSelectedDelivery] = useState<any>(
    selectedRate?.delivery
  );
  const [selectedTransfer, setSelectedTransfer] = useState<any>(
    selectedRate?.transfer || null
  );

  let pickUpRateArray = rates?.pickup_rates[selectedRate?.main?.pickup];
  let deliveryRateArray = rates?.delivery_rates[selectedRate?.main?.delivery];
  let transferRateArray =
    selectedRate?.main?.transfer_rates &&
    selectedRate?.main?.transfer_rates.length > 0
      ? selectedRate?.main?.transfer_rates
      : [];
  const [selectedPickupKey, setSelectedPickupKey] = useState<number | null>();
  const [selectedDeliveryKey, setSelectedDeliveryKey] = useState<
    number | null
  >();
  const [selectedTransferKey, setSelectedTransferKey] = useState<any>(null);
  const filteredDeliveryRateArray = deliveryRateArray?.filter((item: any) =>
    item?.routing[0]?.carrier_name
      ?.toLowerCase()
      ?.includes(searchDelivery.toLowerCase())
  );

  const filteredPickupRateArray = pickUpRateArray?.filter((item: any) =>
    item?.routing[0]?.carrier_name
      ?.toLowerCase()
      ?.includes(searchPickup.toLowerCase())
  );

  const filteredTransferRateArray = transferRateArray?.filter((item: any) =>
    item?.routing[0]?.carrier_name
      ?.toLowerCase()
      ?.includes(searchTransfer.toLowerCase())
  );
  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
  });
  function onClose() {
    setSelectedDeliveryKey(null);
    setSelectedPickupKey(null);
    setSelectedDelivery(null);
    setSelectedPickup(null);
    setShowModal(false);
    removePDLegs();
  }
  function onTransferClose() {
    setSelectedDeliveryKey(null);
    setSelectedPickupKey(null);
    setSelectedTransferKey(null);
    setSelectedTransfer(null);
    setSelectedDelivery(null);
    setSelectedPickup(null);
    setSelectedRate({});
    setSelectedLegsInfo([]);
    setShowModal(false);
    removePDLegs();
  }
  function handleContinue() {
    if (isTransferRequired && !selectedTransfer) {
      enqueueSnackbar(
        'Transfer is mandatory, Please select a transfer to continue.',
        {
          variant: 'error',
        }
      );
      return;
    }
    setSelectedRate({
      ...selectedRate,
      pickup: selectedPickup,
      delivery: selectedDelivery,
      transfer: selectedTransfer,
    });
    setShowModal(false);
  }

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const [sortTransferColumn, setSortTransferColumn] = useState('total');
  const [sortTransferOrder, setSortTransferOrder] = useState('asc');
  const [hoveredTransferColumn, setHoveredTransferColumn] = useState<any>(null);

  const handleSortTransfer = (column: any) => {
    if (sortTransferColumn === column) {
      setSortTransferOrder((prevOrder) =>
        prevOrder === 'asc' ? 'desc' : 'asc'
      );
    } else {
      setSortTransferColumn(column);
      setSortTransferOrder('asc');
    }
  };

  const [sortPickupColumn, setSortPickupColumn] = useState('total');
  const [sortPickupOrder, setSortPickupOrder] = useState('asc');
  const [hoveredPickupColumn, setHoveredPickupColumn] = useState<any>(null);

  const handleSortPickup = (column: any) => {
    if (sortPickupColumn === column) {
      setSortPickupOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortPickupColumn(column);
      setSortPickupOrder('asc');
    }
  };

  const [sortDeliveryColumn, setSortDeliveryColumn] = useState('total');
  const [sortDeliveryOrder, setSortDeliveryOrder] = useState('asc');
  const [hoveredDeliveryColumn, setHoveredDeliveryColumn] = useState<any>(null);

  const handleSortDelivery = (column: any) => {
    if (sortDeliveryColumn === column) {
      setSortDeliveryOrder((prevOrder) =>
        prevOrder === 'asc' ? 'desc' : 'asc'
      );
    } else {
      setSortDeliveryColumn(column);
      setSortDeliveryOrder('asc');
    }
  };

  function removePDLegs() {
    setSelectedLegsInfo((prevLegs: any) => {
      let tempLegs = prevLegs.filter(
        (item: any) => item.leg !== 'P' && item.leg !== 'D'
      );
      return tempLegs;
    });
  }

  function storeLegInfo(type: string, leg: any) {
    if (leg?.routing && leg.routing.length > 0) {
      const selectedLeg = {
        leg: type,
        transit_days: leg?.transit_days,
        delivery_date: leg?.est_delivery_date,
        routing: leg?.routing[0],
        ratesInfo: leg?.rate,
      };

      setSelectedLegsInfo((prevLegs: any) => {
        let tempLegs = [...prevLegs];
        const existingIndex = tempLegs.findIndex((item) => item.leg === type);
        if (existingIndex !== -1) {
          tempLegs.splice(existingIndex, 1);
        }
        tempLegs.push(selectedLeg);
        tempLegs.sort((a, b) => {
          return orderLeg.indexOf(a.leg) - orderLeg.indexOf(b.leg);
        });

        return tempLegs;
      });
    }
  }
  return (
    <div>
      <div className='	'>
        <div className=''>
          <div className=''>
            <div className='d-flex mt-4 justify-content-center align-items-center '>
              <div className=''>
                <div
                  className='btn-group '
                  role='group'
                  aria-label='Basic example'
                  style={{ backgroundColor: '#F3F0F0', borderRadius: '50px' }}
                >
                  <div
                    onClick={() => {
                      setSection('pickup');
                      setSearchDelivery('');
                      setSearchPickup('');
                      setSearchTransfer('');
                    }}
                    id='new'
                    // type='button'
                    className={`lex-18-400 color-main ${
                      section === 'pickup' && 'btn-ubbe-green'
                    }`}
                    style={{
                      borderTopLeftRadius: '50px',
                      borderBottomLeftRadius: '50px',
                      padding: '16px',
                      cursor: 'pointer',
                    }}
                  >
                    Optional Pickup
                  </div>
                  {isTransferRequired && (
                    <div
                      onClick={() => {
                        setSection('transfer');
                        setSearchDelivery('');
                        setSearchPickup('');
                        setSearchTransfer('');
                      }}
                      id='new'
                      // type='button'
                      className={`lex-18-400 color-main ${
                        section === 'transfer' && 'btn-ubbe-green'
                      }`}
                      style={{
                        padding: '16px',
                        cursor: 'pointer',
                      }}
                    >
                      Mandatory Transfer
                    </div>
                  )}
                  <div
                    onClick={() => {
                      setSection('delivery');
                      setSearchDelivery('');
                      setSearchPickup('');
                      setSearchTransfer('');
                    }}
                    id='existing'
                    // type='button'
                    className={`lex-18-400 color-main ${
                      section === 'delivery' && 'btn-ubbe-green'
                    }`}
                    style={{
                      borderTopRightRadius: '50px',
                      borderBottomRightRadius: '50px',
                      padding: '16px',
                      cursor: 'pointer',
                    }}
                  >
                    Optional Delivery
                  </div>
                </div>
              </div>
            </div>
            <div className=' pt-4'>
              {section === 'transfer' ? (
                <div className='col-12'>
                  <div className=''>
                    <div className=''>
                      <div className='mb-4 d-flex justify-content-between'>
                        <div className=''>
                          <div className='lex-20-500 color-black mb-2'>
                            Mandatory Transfer
                          </div>
                          <div>
                            <span
                              className='lex-black-18-300'
                              id='transfer_from'
                            >{`${legA1Routing[0]?.destination} -> `}</span>
                            <span className='lex-black-18-300' id='pickup_to'>
                              {legA2Routing[0]?.origin}
                            </span>
                          </div>
                        </div>
                        <div className='w-25 input-group '>
                          <SearchField
                            id={'search-field'}
                            placeHolder={'Search here'}
                            className={
                              'form-control ubbe-input w-100 width-input'
                            }
                            handleSearchField={setSearchTransfer}
                            setSearchQuery={setSearchTransfer}
                            value={searchTransfer}
                          />
                        </div>
                      </div>
                      <div
                        className='overflow-auto bg-white'
                        style={{ maxHeight: '30rem' }}
                      >
                        <table
                          id='transfer_rate_table'
                          className='table sortable'
                          data-page-length='25'
                        >
                          <thead
                            id='transfer_rate_table_header'
                            className='position-sticky top-0 ubbe-table-header'
                          >
                            <tr>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%', paddingLeft: '38px' }}
                                onClick={() =>
                                  handleSortTransfer('carrier_name')
                                }
                                onMouseEnter={() =>
                                  setHoveredTransferColumn('carrier_name')
                                }
                                onMouseLeave={() =>
                                  setHoveredTransferColumn(null)
                                }
                              >
                                Carrier
                                {sortTransferColumn === 'carrier_name' && (
                                  <span>
                                    <i
                                      className={`sort-icon bi bi-caret-${
                                        sortTransferOrder === 'asc'
                                          ? 'up'
                                          : 'down'
                                      }-fill`}
                                    ></i>
                                  </span>
                                )}
                                {sortTransferColumn !== 'carrier_name' &&
                                  hoveredTransferColumn === 'carrier_name' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: '20px',
                                          display: 'inline-block',
                                          marginLeft: '4px',
                                        }}
                                      >
                                        {' '}
                                        {sortIcon}{' '}
                                      </span>
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() =>
                                  handleSortTransfer('transit_days')
                                }
                                onMouseEnter={() =>
                                  setHoveredTransferColumn('transit_days')
                                }
                                onMouseLeave={() =>
                                  setHoveredTransferColumn(null)
                                }
                              >
                                Est. Business Days
                                {sortTransferColumn === 'transit_days' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortTransferOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortTransferColumn !== 'transit_days' &&
                                  hoveredTransferColumn === 'transit_days' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() =>
                                  handleSortTransfer('est_delivery_date')
                                }
                                onMouseEnter={() =>
                                  setHoveredTransferColumn('est_delivery_date')
                                }
                                onMouseLeave={() =>
                                  setHoveredTransferColumn(null)
                                }
                              >
                                Est. Delivery Date
                                {sortTransferColumn === 'est_delivery_date' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortTransferOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortTransferColumn !== 'est_delivery_date' &&
                                  hoveredTransferColumn ===
                                    'est_delivery_date' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                id='pickup_total_th'
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '20%' }}
                                onClick={() => handleSortTransfer('total')}
                                onMouseEnter={() =>
                                  setHoveredTransferColumn('total')
                                }
                                onMouseLeave={() =>
                                  setHoveredTransferColumn(null)
                                }
                              >
                                Rate (Pre-Tax)
                                {sortTransferColumn === 'total' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortTransferOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortTransferColumn !== 'total' &&
                                  hoveredTransferColumn === 'total' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            id='transfer_rate_table_rows'
                            // className='legs'
                          >
                            {filteredTransferRateArray &&
                            sortedRatesTableData(
                              filteredTransferRateArray,
                              sortTransferColumn,
                              sortTransferOrder
                            ).length > 0 ? (
                              sortedRatesTableData(
                                filteredTransferRateArray,
                                sortTransferColumn,
                                sortTransferOrder
                              ).map((item: any, key: number) => (
                                <tr
                                  key={key}
                                  className={`cursor_pointer ${
                                    selectedTransferKey ===
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id ||
                                    (selectedTransfer &&
                                      JSON.stringify(selectedTransfer) ===
                                        JSON.stringify(item))
                                      ? 'selected-rates-background'
                                      : ''
                                  }`}
                                  onClick={() => {
                                    setSelectedTransfer(item);
                                    setSelectedTransferKey(
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id
                                    );
                                    storeLegInfo('T', item);
                                  }}
                                >
                                  <td
                                    className={'py-3 align-middle text-start'}
                                    style={{
                                      width: '22%',
                                      paddingLeft: '38px',
                                    }}
                                  >
                                    {item?.routing[0]?.carrier_name}
                                    <br />
                                    {item?.routing[0]?.service_name}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '20%' }}
                                  >
                                    {item?.transit_days === -1
                                      ? 'N/A'
                                      : item?.transit_days === 0
                                      ? 'Same Day'
                                      : item?.transit_days}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '20%' }}
                                  >
                                    {formatDateWithDashes(
                                      new Date(item.est_delivery_date)
                                    ) === '1-01-01'
                                      ? 'N/A'
                                      : formatDateWithDashes(
                                          new Date(item.est_delivery_date)
                                        )}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '19%' }}
                                  >
                                    {isPriceHidden
                                      ? '-'
                                      : formatter.format(
                                          parseFloat(item?.rate?.total) -
                                            parseFloat(item?.rate?.tax)
                                        )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr style={{ border: 'none' }}>
                                {' '}
                                <td
                                  colSpan={9}
                                  className='text-center global-text align-middle '
                                  style={{
                                    color: ' #979797                       ',
                                    border: 'none',
                                  }}
                                >
                                  Transfer data not found! Please try again.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : section === 'pickup' ? (
                <div className='col-12'>
                  <div className=''>
                    <div className=''>
                      <div className='mb-4 d-flex justify-content-between'>
                        <div className=''>
                          <div className='lex-20-500 color-black mb-2'>
                            Optional Pickup
                          </div>
                          <div>
                            <span
                              className='lex-black-18-300'
                              id='pickup_from'
                            >{`${originFormContextData?.city} -> `}</span>
                            <span className='lex-black-18-300' id='pickup_to'>
                              {legA1Routing[0]?.origin}
                            </span>
                          </div>
                        </div>
                        <div className='w-25 input-group '>
                          <SearchField
                            id={'search-field'}
                            placeHolder={'Search here'}
                            className={
                              'form-control ubbe-input w-100 width-input'
                            }
                            handleSearchField={setSearchPickup}
                            setSearchQuery={setSearchPickup}
                            value={searchPickup}
                          />
                        </div>
                        {/* <div className='relative w-25'>
                          <input
                            type='search'
                            className='form-control ubbe-input w-100'
                            id='exampleFormControlInput1'
                            placeholder='Search'
                            value={searchPickup}
                            onChange={(e) => {
                              setSearchPickup(e.target.value);
                            }}
                          />
                        </div> */}
                      </div>
                      <div
                        className='overflow-auto bg-white'
                        style={{ maxHeight: '30rem' }}
                      >
                        <table
                          id='pickup_rate_table'
                          className='table sortable'
                          data-page-length='25'
                        >
                          <thead
                            id='pickup_rate_table_header'
                            className='position-sticky top-0 ubbe-table-header'
                          >
                            <tr>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%', paddingLeft: '38px' }}
                                onClick={() => handleSortPickup('carrier_name')}
                                onMouseEnter={() =>
                                  setHoveredPickupColumn('carrier_name')
                                }
                                onMouseLeave={() =>
                                  setHoveredPickupColumn(null)
                                }
                              >
                                Carrier
                                {sortPickupColumn === 'carrier_name' && (
                                  <span>
                                    <i
                                      className={`sort-icon bi bi-caret-${
                                        sortPickupOrder === 'asc'
                                          ? 'up'
                                          : 'down'
                                      }-fill`}
                                    ></i>
                                  </span>
                                )}
                                {sortPickupColumn !== 'carrier_name' &&
                                  hoveredPickupColumn === 'carrier_name' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: '20px',
                                          display: 'inline-block',
                                          marginLeft: '4px',
                                        }}
                                      >
                                        {' '}
                                        {sortIcon}{' '}
                                      </span>
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() => handleSortPickup('transit_days')}
                                onMouseEnter={() =>
                                  setHoveredPickupColumn('transit_days')
                                }
                                onMouseLeave={() =>
                                  setHoveredPickupColumn(null)
                                }
                              >
                                Est. Business Days
                                {sortPickupColumn === 'transit_days' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortPickupOrder === 'asc' ? 'up' : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortPickupColumn !== 'transit_days' &&
                                  hoveredPickupColumn === 'transit_days' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() =>
                                  handleSortPickup('est_delivery_date')
                                }
                                onMouseEnter={() =>
                                  setHoveredPickupColumn('est_delivery_date')
                                }
                                onMouseLeave={() =>
                                  setHoveredPickupColumn(null)
                                }
                              >
                                Est. Delivery Date
                                {sortPickupColumn === 'est_delivery_date' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortPickupOrder === 'asc' ? 'up' : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortPickupColumn !== 'est_delivery_date' &&
                                  hoveredPickupColumn ===
                                    'est_delivery_date' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                id='pickup_total_th'
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '20%' }}
                                onClick={() => handleSortPickup('total')}
                                onMouseEnter={() =>
                                  setHoveredPickupColumn('total')
                                }
                                onMouseLeave={() =>
                                  setHoveredPickupColumn(null)
                                }
                              >
                                Rate (Pre-Tax)
                                {sortPickupColumn === 'total' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortPickupOrder === 'asc' ? 'up' : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortPickupColumn !== 'total' &&
                                  hoveredPickupColumn === 'total' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            id='pickup_rate_table_rows'
                            // className='legs'
                          >
                            {filteredPickupRateArray &&
                            sortedRatesTableData(
                              filteredPickupRateArray,
                              sortPickupColumn,
                              sortPickupOrder
                            ).length > 0 ? (
                              sortedRatesTableData(
                                filteredPickupRateArray,
                                sortPickupColumn,
                                sortPickupOrder
                              ).map((item: any, key: number) => (
                                <tr
                                  key={key}
                                  className={`cursor_pointer ${
                                    selectedPickupKey ===
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id ||
                                    (selectedPickup &&
                                      JSON.stringify(selectedPickup) ===
                                        JSON.stringify(item))
                                      ? 'selected-rates-background'
                                      : ''
                                  }`}
                                  onClick={() => {
                                    setSelectedPickup(item);
                                    setSelectedPickupKey(
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id
                                    );
                                    storeLegInfo('P', item);
                                  }}
                                >
                                  <td
                                    className={'py-3 align-middle text-start'}
                                    style={{
                                      width: '22%',
                                      paddingLeft: '38px',
                                    }}
                                  >
                                    {item?.routing[0]?.carrier_name}
                                    <br />
                                    {item?.routing[0]?.service_name}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '20%' }}
                                  >
                                    {item?.transit_days === -1
                                      ? 'N/A'
                                      : item?.transit_days === 0
                                      ? 'Same Day'
                                      : item?.transit_days}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '20%' }}
                                  >
                                    {formatDateWithDashes(
                                      new Date(item.est_delivery_date)
                                    ) === '1-01-01'
                                      ? 'N/A'
                                      : formatDateWithDashes(
                                          new Date(item.est_delivery_date)
                                        )}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '19%' }}
                                  >
                                    {isPriceHidden
                                      ? '-'
                                      : formatter.format(
                                          parseFloat(item?.rate?.total) -
                                            parseFloat(item?.rate?.tax)
                                        )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr style={{ border: 'none' }}>
                                {' '}
                                <td
                                  colSpan={9}
                                  className='text-center global-text align-middle '
                                  style={{
                                    color: ' #979797                       ',
                                    border: 'none',
                                  }}
                                >
                                  Optional pickup not found! Please try again.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='col-12'>
                  <div className=''>
                    <div className=' '>
                      <div className='mb-4 d-flex justify-content-between'>
                        <div className=''>
                          <div className='lex-20-500 color-black mb-2'>
                            Optional Delivery
                          </div>
                          <div>
                            <span
                              className='lex-black-18-300'
                              id='delivery_from'
                            >{`${
                              selectedRate?.main?.mode_code === 'ATA'
                                ? legA2Routing[0]?.destination
                                : legA1Routing[0]?.destination
                            } -> `}</span>
                            <span
                              className='lex-black-18-300'
                              id='delivery_to_to'
                            >
                              {destinationFormContextData?.city}
                            </span>
                          </div>
                        </div>
                        {/* <div className='relative w-25'>
                          <input
                            type='search'
                            className='form-control ubbe-input w-100'
                            id='exampleFormControlInput1'
                            placeholder='Search'
                            value={searchDelivery}
                            onChange={(e) => {
                              setSearchDelivery(e.target.value);
                            }}
                          />
                        </div> */}
                        <div className='w-25 input-group '>
                          <SearchField
                            id={'search-field-pick'}
                            placeHolder={'Search here'}
                            className={
                              'form-control ubbe-input w-100 width-input'
                            }
                            handleSearchField={setSearchDelivery}
                            setSearchQuery={setSearchDelivery}
                            value={searchDelivery}
                          />
                        </div>
                      </div>
                      <div
                        className='overflow-auto bg-white'
                        style={{ maxHeight: '30rem' }}
                      >
                        <table
                          id='delivery_rate_table'
                          className='table sortable'
                          data-page-length='25'
                        >
                          <thead
                            id='delivery_rate_table_header'
                            className='position-sticky top-0 ubbe-table-header'
                          >
                            <tr>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%', paddingLeft: '38px' }}
                                onClick={() =>
                                  handleSortDelivery('carrier_name')
                                }
                                onMouseEnter={() =>
                                  setHoveredDeliveryColumn('carrier_name')
                                }
                                onMouseLeave={() =>
                                  setHoveredDeliveryColumn(null)
                                }
                              >
                                Carrier
                                {sortDeliveryColumn === 'carrier_name' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortDeliveryOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortDeliveryColumn !== 'carrier_name' &&
                                  hoveredDeliveryColumn === 'carrier_name' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() =>
                                  handleSortDelivery('transit_days')
                                }
                                onMouseEnter={() =>
                                  setHoveredDeliveryColumn('transit_days')
                                }
                                onMouseLeave={() =>
                                  setHoveredDeliveryColumn(null)
                                }
                              >
                                Est. Business Days
                                {sortDeliveryColumn === 'transit_days' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortDeliveryOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortDeliveryColumn !== 'transit_days' &&
                                  hoveredDeliveryColumn === 'transit_days' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '24%' }}
                                onClick={() =>
                                  handleSortDelivery('est_delivery_date')
                                }
                                onMouseEnter={() =>
                                  setHoveredDeliveryColumn('est_delivery_date')
                                }
                                onMouseLeave={() =>
                                  setHoveredDeliveryColumn(null)
                                }
                              >
                                Est. Delivery Date
                                {sortDeliveryColumn === 'est_delivery_date' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortDeliveryOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortDeliveryColumn !== 'est_delivery_date' &&
                                  hoveredDeliveryColumn ===
                                    'est_delivery_date' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                              <th
                                id='delivery_total_th'
                                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                                style={{ width: '20%' }}
                                onClick={() => handleSortDelivery('total')}
                                onMouseEnter={() =>
                                  setHoveredDeliveryColumn('total')
                                }
                                onMouseLeave={() =>
                                  setHoveredDeliveryColumn(null)
                                }
                              >
                                Rate (Pre-Tax)
                                {sortDeliveryColumn === 'total' && (
                                  <i
                                    className={`sort-icon bi bi-caret-${
                                      sortDeliveryOrder === 'asc'
                                        ? 'up'
                                        : 'down'
                                    }-fill`}
                                  ></i>
                                )}
                                {sortDeliveryColumn !== 'total' &&
                                  hoveredDeliveryColumn === 'total' && (
                                    <span
                                      style={{
                                        width: '20px',
                                        display: 'inline-block',
                                        marginLeft: '4px',
                                      }}
                                    >
                                      {' '}
                                      {sortIcon}{' '}
                                    </span>
                                  )}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            id='delivery_rate_table_rows'
                            // className='legs'
                          >
                            {filteredDeliveryRateArray &&
                            sortedRatesTableData(
                              filteredDeliveryRateArray,
                              sortDeliveryColumn,
                              sortDeliveryOrder
                            ).length > 0 ? (
                              sortedRatesTableData(
                                filteredDeliveryRateArray,
                                sortDeliveryColumn,
                                sortDeliveryOrder
                              ).map((item: any, key: number) => (
                                <tr
                                  key={key}
                                  className={`cursor_pointer ${
                                    selectedDeliveryKey ===
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id ||
                                    (selectedDelivery &&
                                      JSON.stringify(selectedDelivery) ===
                                        JSON.stringify(item))
                                      ? 'selected-rates-background'
                                      : ''
                                  }`}
                                  onClick={() => {
                                    setSelectedDelivery(item);
                                    storeLegInfo('D', item);
                                    setSelectedDeliveryKey(
                                      item?.routing[0]?.service_code +
                                        item?.routing[0]?.carrier_id
                                    );
                                  }}
                                >
                                  <td
                                    className={'py-3 align-middle text-start'}
                                    style={{
                                      width: '22%',
                                      paddingLeft: '38px',
                                    }}
                                  >
                                    {item?.routing[0]?.carrier_name}
                                    <br />
                                    {item?.routing[0]?.service_name}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '16%' }}
                                  >
                                    {item?.transit_days === -1
                                      ? 'N/A'
                                      : item?.transit_days === 0
                                      ? 'Same Day'
                                      : item?.transit_days}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '16%' }}
                                  >
                                    {formatDateWithDashes(
                                      new Date(item.est_delivery_date)
                                    ) === '1-01-01'
                                      ? 'N/A'
                                      : formatDateWithDashes(
                                          new Date(item.est_delivery_date)
                                        )}
                                  </td>
                                  <td
                                    className='py-3 text-start align-middle'
                                    style={{ width: '19%' }}
                                  >
                                    {formatter.format(
                                      parseFloat(item?.rate?.total) -
                                        parseFloat(item?.rate?.tax)
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr style={{ border: 'none' }}>
                                {' '}
                                <td
                                  colSpan={9}
                                  className='text-center global-text align-middle '
                                  style={{
                                    color: ' #979797                       ',
                                    border: 'none',
                                  }}
                                >
                                  Optional delivery not found! Please try again.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='d-flex  mt-5 justify-content-between'>
            <div></div>
            <div className='d-flex gap-2'>
              {!isTransferRequired && (
                <button
                  type='button'
                  className='btn btn-ubbe-secondary'
                  disabled={isTransferRequired && !selectedTransfer}
                  onClick={onClose}
                >
                  No Pickup or Delivery
                </button>
              )}
              {isTransferRequired && (
                <button
                  type='button'
                  className='btn btn-ubbe-secondary'
                  onClick={onTransferClose}
                  style={{ width: '111px' }}
                >
                  Close
                </button>
              )}
              <button
                type='button'
                className='btn btn-ubbe-new-blue'
                disabled={isTransferRequired && !selectedTransfer}
                onClick={() => handleContinue()}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PickupAndDeliveryModals;
